import React from "react";
import { useTranslation } from "react-i18next";

export default function EpkTextInfo() {
  const { t } = useTranslation();
  return (
    <p className="tw-text-sm tw-text-white/50 tw-m-0">
      {t("Find all your film EPKs that you've created here.")}
    </p>
  );
}
